export interface IWaitlistAllocationConfig {
    centerId: number;
    cpra98Points: number;
    cpra99Points: number;
    daysWaitPoints: number;
    zeroEpletMmPoints: number;
    lowEpletMmPoints: number;
    pediatricMaxAge: number;
    pediatricWaitDays: number;
    pediatricWaitPoints: number;
    pediatricZeroEpletMmPoints: number;
    pediatricLowEpletMmPoints: number;
}
